module.exports = __webpack_public_path__ + "assets/images/views/close_view_button_ru.png";